import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import './scss/app.scss'
import { store } from "./store-init";

require('./apiConfig');
require('./components/component-loader');

import {apiURIMain} from './apiConfig';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

Vue.filter('formatMSISDN', function(value) {
    if (!value || value.length !== 10) return value;
    return `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6, 10)}`;
});

Vue.filter('imageIdToURL', function(value, attrs = {}) {
    const width = attrs.w || 400,
        height = attrs.h || 300;

    if(!value) 
        return `https://placehold.co/${width}x${height}/b3cdbf/ffffff?text=No+Image`;

    if(attrs.w && attrs.h) 
        return `${apiURIMain}img/render/${value}/${width}/${height}/rezied.jpg`;
    else 
        return `${apiURIMain}img/render/${value}`;

});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
